/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadAdmissionFlagsInnerAdmissionFlagAliasesInner
 */
export interface LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlagAliasesInner
     */
    value?: string;
}

/**
 * Check if a given object implements the LeadAdmissionFlagsInnerAdmissionFlagAliasesInner interface.
 */
export function instanceOfLeadAdmissionFlagsInnerAdmissionFlagAliasesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSON(json: any): LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    return LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionFlagsInnerAdmissionFlagAliasesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSON(value?: LeadAdmissionFlagsInnerAdmissionFlagAliasesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

